import { useIsInteractiveMode } from "../contexts/InteractiveContext";
const IfInteractive = ({ children }) => {
  const isInteractive = useIsInteractiveMode();
  return isInteractive ? children : null;
};
export default IfInteractive;
